import React, { useEffect, useState, useContext } from "react"
import Header from "../../../layouts/Header"
import { createTheme, ThemeProvider } from "@mui/material/styles"

import VerPicking from "./Pickings"
import { PickingContextProvider } from "../PickingContext"

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const CrearPicking = () => {
  return (
    <PickingContextProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <VerPicking />
      </ThemeProvider>
    </PickingContextProvider>
  )
}

export default CrearPicking
